import React, { MouseEventHandler } from "react";
import styled from "styled-components";

interface propsData {
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  value?: string;
  id?: string;
  readonly?: boolean;
  title?: string;
  placeholder?: string;
}

const RejectionReason = (props: propsData) => {
  return (
    <RejectionReasonBox>
      <div>
        <dt>{props.title ? props.title : "반려사유"}</dt>
        <dd>
          <textarea
            placeholder={props.placeholder ? props.placeholder : "반려 사유입니다."}
            readOnly={props.readonly}
            id={props.id}
            defaultValue={props.value}
            onChange={props.onChange}
          />
        </dd>
      </div>
    </RejectionReasonBox>
  );
};

const RejectionReasonBox = styled.dl`
  padding: 20px 45px 0;
  dt {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 10px;
  }
  dd {
    &.divide {
      ${({ theme }) => theme.flexBox.flexMixin()}
      > p {
        font-size: 18px;
        font-weight: 700;
      }
    }
  }
  textarea {
    width: 100%;
    height: 150px;
    padding: 15px;
    border: none;
    border-radius: 4px;
    background: #f4f4f4;
    resize: none;
    outline: none;
    color: #001827;
    font-family: "Roboto";
    font-weight: 500;
    font-size: 16px;
  }
`;

export default RejectionReason;
